<div #root class="page">
  <!-- HERO / BACKDROP -->
  <div class="hero-bg" data-hero-bg></div>

  <!-- ✅ Flash layer (GSAP/JS flashes) -->
  <div class="flash-layer" data-flash-layer aria-hidden="true"></div>

  <div class="aurora aurora--1 blob"></div>
  <div class="aurora aurora--2 blob"></div>
  <div class="aurora aurora--3 blob"></div>

  <!-- HEADER -->
  <header class="topbar">
    <div class="container topbar__inner glass">
      <div class="brand" (click)="go('inicio')" role="button" tabindex="0">
        <img src="assets/img/logo.png" alt="Karen Bentancor" class="brand__mark" />
        <div class="brand__txt">
          <div class="brand__name kb-h">Karen Bentancor</div>
          <div class="brand__sub kb-muted">Bienestar · Rehabilitación · Movimiento</div>
        </div>
      </div>

      <!-- ✅ NAV: SOLO DROPDOWN -->
      <nav class="nav" aria-label="Secciones">
        <details class="navDrop" #navDrop>
          <summary class="navDrop__btn">
            <span class="navDrop__label">Sección:</span>
            <span class="navDrop__value">{{ activeSectionLabel }}</span>
            <span class="navDrop__chev">▾</span>
          </summary>

          <div class="navDrop__menu glass" role="menu">
            <button
              class="navDrop__item"
              *ngFor="let n of nav"
              role="menuitem"
              [class.is-active]="activeSection === n.id"
              (click)="goFromDropdown(n.id, $event)">
              {{ n.label }}
            </button>
          </div>
        </details>
      </nav>

      <div class="actions">
        <!-- WhatsApp -->
        <div class="heroCard__line" (click)="openWhatsApp()" style="cursor: pointer;">
          <div class="heroCard__left">
            <svg class="icon icon--wa" viewBox="0 0 24 24" aria-hidden="true">
              <path d="M20.52 3.48A11.86 11.86 0 0 0 12.04 0C5.4 0 .04 5.36.04 12c0 2.1.55 4.16 1.6 5.97L0 24l6.2-1.63a11.9 11.9 0 0 0 5.83 1.49h.01c6.63 0 12-5.36 12-12 0-3.2-1.25-6.21-3.52-8.38ZM12.04 21.9a9.9 9.9 0 0 1-5.04-1.38l-.36-.21-3.68.97.98-3.59-.23-.37A9.88 9.88 0 0 1 2.14 12c0-5.47 4.45-9.9 9.92-9.9 2.64 0 5.12 1.03 6.98 2.89A9.83 9.83 0 0 1 21.9 12c0 5.46-4.44 9.9-9.86 9.9Zm5.44-7.41c-.3-.15-1.77-.87-2.05-.97-.28-.1-.48-.15-.68.15-.2.3-.78.97-.96 1.17-.18.2-.35.22-.65.07-.3-.15-1.25-.46-2.38-1.47-.88-.78-1.47-1.75-1.64-2.05-.17-.3-.02-.46.13-.61.13-.13.3-.35.45-.53.15-.18.2-.3.3-.5.1-.2.05-.37-.02-.52-.07-.15-.68-1.64-.93-2.25-.24-.58-.49-.5-.68-.51h-.58c-.2 0-.52.07-.8.37-.28.3-1.05 1.03-1.05 2.52s1.08 2.94 1.23 3.14c.15.2 2.13 3.25 5.16 4.56.72.31 1.28.5 1.72.64.72.23 1.38.2 1.9.12.58-.09 1.77-.72 2.02-1.42.25-.7.25-1.3.18-1.42-.07-.12-.27-.2-.57-.35Z"/>
            </svg>
          </div>
          <span class="value">099448469</span>
        </div>

        <!-- Instagram -->
        <div class="heroCard__line heroCard__line--instagram" (click)="openInstagram()" style="cursor: pointer;">
          <div class="heroCard__left">
            <svg class="icon icon--ig" viewBox="0 0 24 24" aria-hidden="true">
              <path d="M12 2.16c3.2 0 3.58.01 4.85.07 1.17.05 1.97.24 2.43.41.62.24 1.06.53 1.52.99.46.46.75.9.99 1.52.17.46.36 1.26.41 2.43.06 1.27.07 1.65.07 4.85s-.01 3.58-.07 4.85c-.05 1.17-.24 1.97-.41 2.43-.24.62-.53 1.06-.99 1.52-.46.46-.9.75-1.52.99-.46.17-1.26.36-2.43.41-1.27.06-1.65.07-4.85.07s-3.58-.01-4.85-.07c-1.17-.05-1.97-.24-2.43-.41-.62-.24-1.06-.53-1.52-.99-.46-.46-.75-.9-.99-1.52-.17-.46-.36-1.26-.41-2.43-.06-1.27-.07-1.65-.07-4.85s.01-3.58.07-4.85c.05-1.17.24-1.97.41-2.43.24-.62.53-1.06.99-1.52.46-.46.9-.75 1.52-.99.46-.17 1.26-.36 2.43-.41 1.27-.06 1.65-.07 4.85-.07Zm0-2.16C8.74 0 8.33.01 7.05.07 5.78.13 4.9.33 4.17.61 3.41.9 2.76 1.3 2.11 1.95 1.46 2.6 1.06 3.25.77 4.01.49 4.74.29 5.62.23 6.89.17 8.17.16 8.58.16 12s.01 3.83.07 5.11c.06 1.27.26 2.15.54 2.88.29.76.69 1.41 1.34 2.06.65.65 1.3 1.05 2.06 1.34.73.28 1.61.48 2.88.54 1.28.06 1.69.07 5.11.07s3.83-.01 5.11-.07c1.27-.06 2.15-.26 2.88-.54.76-.29 1.41-.69 2.06-1.34.65-.65 1.05-1.3 1.34-2.06.28-.73.48-1.61.54-2.88.06-1.28.07-1.69.07-5.11s-.01-3.83-.07-5.11c-.06-1.27-.26-2.15-.54-2.88-.29-.76-.69-1.41-1.34-2.06-.65-.65-1.3-1.05-2.06-1.34-.73-.28-1.61-.48-2.88-.54C15.83.01 15.42 0 12 0Z"/>
              <path d="M12 5.84A6.16 6.16 0 1 0 12 18.16 6.16 6.16 0 0 0 12 5.84Zm0 10.16A4 4 0 1 1 12 8a4 4 0 0 1 0 8Z"/>
              <circle cx="18.4" cy="5.6" r="1.44"/>
            </svg>
          </div>
          <span class="value">&#64;karenbentancor</span>
        </div>
      </div>
    </div>
  </header>

  <!-- MAIN -->
  <main>
    <!-- Section: INICIO -->
    <section id="inicio" class="hero container">
      <div class="hero__grid">
        <div class="hero__left">
          <div class="kb-pill" data-reveal>
            <span class="dot dot--live"></span>
            Atención en Melo — 18 de Julio 624, Melo
          </div>

          <h1 class="hero__title kb-h" data-reveal>
            Soporte inteligente<br />
            para tu movimiento
          </h1>

          <p class="hero__lead kb-muted" data-reveal>
            Kinesio Tape, bienestar y acompañamiento en procesos de rehabilitación.
            Un enfoque moderno, práctico y personalizado.
          </p>

          <div class="hero__cta" data-reveal>
            <button class="kb-btn" (click)="go('contacto')">Reservar / Consultar</button>
            <button class="kb-btn kb-btn--ghost" (click)="go('servicios')">Ver servicios</button>
            <button class="kb-btn kb-btn--gold" (click)="openPractices()">Prácticas realizadas</button>
          </div>

          <div class="hero__chips" data-reveal>
            <span class="chip">✅ Alivio del dolor</span>
            <span class="chip">✅ Menos inflamación</span>
            <span class="chip">✅ Mejor postura</span>
            <span class="chip">✅ Recuperación</span>
          </div>
        </div>

        <div class="hero__right">
          <div class="heroCard glass" data-reveal>
            <div class="heroCard__top">
              <div class="heroCard__badge">Contacto</div>
              <div class="heroCard__meta kb-muted">Respuesta rápida por WhatsApp</div>
            </div>

            <!-- WhatsApp -->
            <div class="heroCard__line" (click)="openWhatsApp()" style="cursor:pointer;">
              <div class="heroCard__left">
                <svg class="icon icon--wa" viewBox="0 0 24 24" aria-hidden="true">
                  <path d="M20.52 3.48A11.86 11.86 0 0 0 12.04 0C5.4 0 .04 5.36.04 12c0 2.1.55 4.16 1.6 5.97L0 24l6.2-1.63a11.9 11.9 0 0 0 5.83 1.49h.01c6.63 0 12-5.36 12-12 0-3.2-1.25-6.21-3.52-8.38ZM12.04 21.9a9.9 9.9 0 0 1-5.04-1.38l-.36-.21-3.68.97.98-3.59-.23-.37A9.88 9.88 0 0 1 2.14 12c0-5.47 4.45-9.9 9.92-9.9 2.64 0 5.12 1.03 6.98 2.89A9.83 9.83 0 0 1 21.9 12c0 5.46-4.44 9.9-9.86 9.9Zm5.44-7.41c-.3-.15-1.77-.87-2.05-.97-.28-.1-.48-.15-.68.15-.2.3-.78.97-.96 1.17-.18.2-.35.22-.65.07-.3-.15-1.25-.46-2.38-1.47-.88-.78-1.47-1.75-1.64-2.05-.17-.3-.02-.46.13-.61.13-.13.3-.35.45-.53.15-.18.20-.30.30-.5.1-.2.05-.37-.02-.52-.07-.15-.68-1.64-.93-2.25-.24-.58-.49-.5-.68-.51h-.58c-.2 0-.52.07-.8.37-.28.3-1.05 1.03-1.05 2.52s1.08 2.94 1.23 3.14c.15.20 2.13 3.25 5.16 4.56.72.31 1.28.5 1.72.64.72.23 1.38.2 1.9.12.58-.09 1.77-.72 2.02-1.42.25-.7.25-1.3.18-1.42-.07-.12-.27-.2-.57-.35Z"/>
                </svg>
                <span class="label">WhatsApp</span>
              </div>
              <span class="value">099448469</span>
            </div>

            <!-- Instagram -->
            <div class="heroCard__line" (click)="openInstagram()" style="cursor:pointer;">
              <div class="heroCard__left">
                <svg class="icon icon--ig" viewBox="0 0 24 24" aria-hidden="true">
                  <path d="M12 2.16c3.2 0 3.58.01 4.85.07 1.17.05 1.97.24 2.43.41.62.24 1.06.53 1.52.99.46.46.75.9.99 1.52.17.46.36 1.26.41 2.43.06 1.27.07 1.65.07 4.85s-.01 3.58-.07 4.85c-.05 1.17-.24 1.97-.41 2.43-.24.62-.53 1.06-.99 1.52-.46.46-.9.75-1.52.99-.46.17-1.26.36-2.43.41-1.27.06-1.65.07-4.85.07s-3.58-.01-4.85-.07c-1.17-.05-1.97-.24-2.43-.41-.62-.24-1.06-.53-1.52-.99-.46-.46-.75-.9-.99-1.52-.17-.46-.36-1.26-.41-2.43-.06-1.27-.07-1.65-.07-4.85s.01-3.58.07-4.85c.05-1.17.24-1.97.41-2.43.24-.62.53-1.06.99-1.52.46-.46.9-.75 1.52-.99.46-.17 1.26-.36 2.43-.41 1.27-.06 1.65-.07 4.85-.07Zm0-2.16C8.74 0 8.33.01 7.05.07 5.78.13 4.9.33 4.17.61 3.41.9 2.76 1.3 2.11 1.95 1.46 2.6 1.06 3.25.77 4.01.49 4.74.29 5.62.23 6.89.17 8.17.16 8.58.16 12s.01 3.83.07 5.11c.06 1.27.26 2.15.54 2.88.29.76.69 1.41 1.34 2.06.65.65 1.3 1.05 2.06 1.34.73.28 1.61.48 2.88.54 1.28.06 1.69.07 5.11.07s3.83-.01 5.11-.07c1.27-.06 2.15-.26 2.88-.54.76-.29 1.41-.69 2.06-1.34.65-.65 1.05-1.3 1.34-2.06.28-.73.48-1.61.54-2.88.06-1.28.07-1.69.07-5.11s-.01-3.83-.07-5.11c-.06-1.27-.26-2.15-.54-2.88-.29-.76-.69-1.41-1.34-2.06-.65-.65-1.3-1.05-2.06-1.34-.73-.28-1.61-.48-2.88-.54C15.83.01 15.42 0 12 0Z"/>
                  <path d="M12 5.84A6.16 6.16 0 1 0 12 18.16 6.16 6.16 0 0 0 12 5.84Zm0 10.16A4 4 0 1 1 12 8a4 4 0 0 1 0 8Z"/>
                  <circle cx="18.4" cy="5.6" r="1.44"/>
                </svg>
                <span class="label">Instagram</span>
              </div>
              <span class="value">&#64;karenbentancor</span>
            </div>

            <!-- Dirección -->
            <div class="heroCard__line">
              <div class="heroCard__left">
                <span class="label">Dirección</span>
              </div>
              <span class="value">18 de Julio 624, Melo</span>
            </div>

            <div class="heroCard__actions">
              <button class="kb-btn" (click)="openWhatsApp()">Escribir ahora</button>
              <button class="kb-btn kb-btn--ghost" (click)="openInstagram()">Ver Instagram</button>
            </div>
          </div>

          <div class="hero__ornament hero__ornament--a"></div>
          <div class="hero__ornament hero__ornament--b"></div>
        </div>
      </div>
    </section>

    <!-- Section: SERVICIOS -->
    <section id="servicios" class="section container" data-stagger>
      <div class="section__head" data-item>
        <h2 class="kb-h">Servicios</h2>
        <p class="kb-muted">Elegí el enfoque según tu objetivo. Evaluación y aplicación personalizadas.</p>
      </div>

      <div class="cards">
        <article class="card glass" *ngFor="let s of services" data-item>
          <div class="card__tag">{{ s.tag }}</div>
          <h3 class="card__title kb-h">{{ s.title }}</h3>
          <p class="kb-muted">{{ s.desc }}</p>
          <ul class="card__list">
            <li *ngFor="let b of s.bullets">{{ b }}</li>
          </ul>
          <div class="card__foot">
            <button class="kb-btn" (click)="go('contacto')">Consultar</button>
            <button class="kb-btn kb-btn--ghost" (click)="openWhatsApp()">WhatsApp</button>
          </div>
        </article>
      </div>
    </section>

    <!-- Section: ENFOQUE -->
    <section id="enfoque" class="section container" data-stagger>
      <div class="section__head" data-item>
        <h2 class="kb-h">Enfoque</h2>
        <p class="kb-muted">
          Trabajo con una mirada práctica y personalizada: evaluamos, definimos objetivo y aplicamos el soporte adecuado
          para que vuelvas a moverte con confianza.
        </p>
      </div>

      <div class="cards cards--3">
        <article class="card glass" data-item>
          <div class="card__tag">1 · Evaluación</div>
          <h3 class="card__title kb-h">Entender tu caso</h3>
          <p class="kb-muted">
            Conversamos sobre dolor, rutina y objetivos. La colocación y el plan dependen de una evaluación real.
          </p>
          <ul class="card__list">
            <li>Historia + zona + actividad</li>
            <li>Test simple de movimiento</li>
            <li>Objetivo claro</li>
          </ul>
        </article>

        <article class="card glass" data-item>
          <div class="card__tag">2 · Aplicación</div>
          <h3 class="card__title kb-h">Soporte inteligente</h3>
          <p class="kb-muted">
            Kinesio Tape y/o indicaciones específicas para acompañar la recuperación sin inmovilizar.
          </p>
          <ul class="card__list">
            <li>Dolor / inflamación</li>
            <li>Postura / propiocepción</li>
            <li>Vuelta progresiva</li>
          </ul>
        </article>

        <article class="card glass" data-item>
          <div class="card__tag">3 · Seguimiento</div>
          <h3 class="card__title kb-h">Ajuste según evolución</h3>
          <p class="kb-muted">
            Vemos cómo responde tu cuerpo y ajustamos. La idea es que avances de forma segura y sostenida.
          </p>
          <ul class="card__list">
            <li>Revisión y re-colocación</li>
            <li>Tips de cuidado</li>
            <li>Recomendaciones simples</li>
          </ul>
        </article>
      </div>

      <div class="section__cta" data-item>
        <button class="kb-btn" (click)="openWhatsApp()">Consultar por WhatsApp</button>
        <button class="kb-btn kb-btn--ghost" (click)="go('servicios')">Ver servicios</button>
        <button class="kb-btn kb-btn--ghost" (click)="openPractices()">Ver prácticas realizadas</button>
      </div>
    </section>

    <!-- Section: FAQ -->
    <section id="faq" class="section container" data-stagger>
      <div class="section__head" data-item>
        <h2 class="kb-h">Dudas frecuentes</h2>
        <p class="kb-muted">Respuestas rápidas para que vayas con seguridad.</p>
      </div>

      <div class="faq">
        <details class="faq__item glass" *ngFor="let f of faqs" data-item>
          <summary class="faq__q">
            <span class="kb-h">{{ f.q }}</span>
            <span class="faq__icon">+</span>
          </summary>
          <div class="faq__a kb-muted">{{ f.a }}</div>
        </details>
      </div>
    </section>

    <!-- Section: CONTACTO -->
    <section id="contacto" class="section container" data-stagger>
      <div class="section__head" data-item>
        <h2 class="kb-h">Contacto</h2>
        <p class="kb-muted">Consultá por turnos o envianos tu mensaje. Te respondemos a la brevedad.</p>
      </div>

      <div class="contactGrid">
        <!-- FORMULARIO -->
        <div class="contactCard glass" data-item>
          <div class="contactCard__top">
            <div class="heroCard__badge">Enviar mensaje</div>
            <div class="kb-muted">Respuesta rápida</div>
          </div>

          <form class="form" [formGroup]="form" (ngSubmit)="submit()">
            <div class="field">
              <label class="field__label">Nombre</label>
              <input
                class="field__input"
                type="text"
                formControlName="name"
                placeholder="Tu nombre"
              />
            </div>

            <div class="field">
              <label class="field__label">Teléfono (opcional)</label>
              <input
                class="field__input"
                type="tel"
                formControlName="phone"
                placeholder="Tu teléfono"
              />
            </div>

            <div class="field">
              <label class="field__label">Mensaje</label>
              <textarea
                class="field__input field__input--ta"
                formControlName="message"
                placeholder="¿Cuál es tu consulta?"
              ></textarea>
            </div>

            <button
              type="submit"
              class="kb-btn form__btn"
              [disabled]="submitting">
              {{ submitting ? 'Enviando...' : 'Enviar por WhatsApp' }}
            </button>

            @if (submitted) {
              <div class="form__ok">✅ Mensaje enviado correctamente</div>
            }
          </form>
        </div>

        <!-- MAPA -->
        <div class="mapCard glass" data-item>
          <div class="mapCard__head">
            <div class="heroCard__badge">Ubicación</div>
            <div class="kb-muted">18 de Julio 624, Melo</div>
          </div>

          <div class="mapWrap">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3369.7984884905723!2d-54.167726200000004!3d-32.3709509!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x95092bd4b90118d7%3A0xcccc4f5aa1101c96!2s18%20de%20Julio%20624%2C%2037000%20Melo%2C%20Departamento%20de%20Cerro%20Largo!5e0!3m2!1ses!2suy!4v1769413993624!5m2!1ses!2suy"
              width="600"
              height="450"
              style="border:0;"
              allowfullscreen=""
              loading="lazy"
              referrerpolicy="no-referrer-when-downgrade">
            </iframe>
          </div>

          <div class="mapCard__foot">
            <button class="kb-btn" (click)="openWhatsApp()">Escribir ahora</button>
            <button class="kb-btn kb-btn--ghost" (click)="go('inicio')">Volver arriba</button>
          </div>
        </div>
      </div>
    </section>

    <footer class="footer glass" data-item>
      <div class="footer__left">
        <div class="footer__brand kb-h">Karen Bentancor</div>
        <div class="kb-muted">DESARROLLO WEB: JUAN NAVARRETE +598 92 454 958</div>     
        <div class="kb-muted">© {{ year }} · 18 de Julio 624, Melo</div>
      </div>
      <div class="footer__right">
        <a class="footer__link" [href]="socials.instagram" target="_blank" rel="noreferrer">Instagram</a>
        <button class="footer__link" (click)="openWhatsApp()">WhatsApp</button>
        <button class="footer__link" (click)="go('inicio')">Volver arriba ↑</button>
      </div>
    </footer>
  </main>

  <!-- ============================================================ -->
  <!-- PRÁCTICAS REALIZADAS - MODAL GALERÍA WOW -->
  <!-- ============================================================ -->
  @if (isPracticesOpen) {
    <div class="pmOverlay" (click)="onOverlayClick($event)" role="dialog" aria-modal="true" aria-label="Galería de prácticas realizadas">
      <!-- Aurora gradients en el overlay -->
      <div class="pmAurora1"></div>
      <div class="pmAurora2"></div>
      
      <div class="pmModal glass" (click)="$event.stopPropagation()">
        <!-- Header premium -->
        <div class="pmHead">
          <div class="pmHead__content">
            <h2 class="pmHead__title kb-h">Prácticas realizadas</h2>
            <div class="pmHead__meta">
              <span class="pmHead__badge">Galería</span>
              <span class="pmHead__count">{{ practiceImgs.length }} fotos</span>
            </div>
          </div>
          <button class="pmClose" (click)="closePractices()" aria-label="Cerrar galería">
            <span class="pmClose__icon">✕</span>
          </button>
        </div>

        <!-- Grid WOW -->
        <div class="pmGrid">
          @for (img of practiceImgs; track img; let i = $index) {
            <div class="pmThumb" (click)="openViewer(i)" role="button" tabindex="0" [attr.aria-label]="'Ver práctica ' + (i + 1)">
              <div class="pmThumb__inner">
                <img [src]="img" [alt]="'Práctica ' + (i + 1)" loading="lazy" />
                <div class="pmThumb__overlay">
                  <span class="pmThumb__icon">🔍</span>
                </div>
              </div>
            </div>
          }
        </div>
      </div>

      <!-- Viewer -->
      @if (viewerIndex !== null) {
        <div class="practices-viewer" (click)="onOverlayClick($event)">
          <div class="viewer-container" (click)="$event.stopPropagation()">
            <button class="viewer-close" (click)="closeViewer()" aria-label="Cerrar viewer">
              ✕
            </button>
            
            <button class="viewer-nav viewer-nav--prev" 
                    (click)="prevImg()" 
                    [disabled]="viewerIndex === 0"
                    aria-label="Imagen anterior">
              ‹
            </button>
            
            <img class="viewer-img" [src]="practiceImgs[viewerIndex]" [alt]="'Práctica ' + (viewerIndex + 1)" />
            
            <button class="viewer-nav viewer-nav--next" 
                    (click)="nextImg()" 
                    [disabled]="viewerIndex === practiceImgs.length - 1"
                    aria-label="Siguiente imagen">
              ›
            </button>
            
            <div class="viewer-counter">{{ viewerIndex + 1 }} / {{ practiceImgs.length }}</div>
          </div>
        </div>
      }
    </div>
  }

  <!-- ============================================================ -->
  <!-- BENEFICIOS - WIDGET FLOTANTE -->
  <!-- ============================================================ -->
  @if (showBenefits) {
    <div class="benefitsFloat glass">
      <div class="benefitsFloat__header" (click)="toggleBenefits()" role="button" tabindex="0">
        <span class="benefitsFloat__title">Beneficios</span>
        <span class="benefitsFloat__icon">▼</span>
      </div>
      
      <div class="benefitsFloat__body" [style.display]="benefitsOpen ? 'block' : 'none'">
        <ul class="benefitsFloat__list">
          @for (benefit of benefits; track benefit) {
            <li class="benefitsFloat__item">{{ benefit }}</li>
          }
        </ul>
      </div>
    </div>
  }
</div>
